import { ReactElement } from 'react';

export const StreamlinesStatistics = ({ fill, stroke }: any): ReactElement => {
  return (
    <svg x="0px" y="0px" width={'24px'} height={'24px'} viewBox="0 0 24 24">
      {/* Chart bars */}
      <rect
        x="3"
        y="14"
        width="3"
        height="6"
        stroke={stroke ?? 'currentColor'}
        fill={fill ?? 'currentColor'}
        strokeWidth="0.5"
        rx="0.5"
      />
      <rect
        x="8"
        y="8"
        width="3"
        height="12"
        stroke={stroke ?? 'currentColor'}
        fill={fill ?? 'currentColor'}
        strokeWidth="0.5"
        rx="0.5"
      />
      <rect
        x="13"
        y="11"
        width="3"
        height="9"
        stroke={stroke ?? 'currentColor'}
        fill={fill ?? 'currentColor'}
        strokeWidth="0.5"
        rx="0.5"
      />
      <rect
        x="18"
        y="6"
        width="3"
        height="14"
        stroke={stroke ?? 'currentColor'}
        fill={fill ?? 'currentColor'}
        strokeWidth="0.5"
        rx="0.5"
      />

      {/* Trend line */}
      <path
        d="M4.5 12 L9.5 7 L14.5 9 L19.5 4"
        stroke={stroke ?? 'currentColor'}
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
